import { render, staticRenderFns } from "./IvyClientDetailPanel.vue?vue&type=template&id=2cf94070&"
import script from "./IvyClientDetailPanel.vue?vue&type=script&lang=js&"
export * from "./IvyClientDetailPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports